import { LayoutComponent } from './components/layout/layout.component';
import { routerSegments } from './consts/routes';
import { Routes } from '@angular/router';
import {
  PublicAccessDeniedPageComponent,
  PublicEmailVerificationPageComponent,
  PublicResetPasswordPageComponent,
} from '@auth';
import { authenticatedGuard } from './guards/authenticated.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: routerSegments.home },
  {
    path: routerSegments.home,
    canActivate: [authenticatedGuard],
    loadComponent: () => LayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('@share-chat').then((m) => m.libChatRoutes),
      },
    ],
  },
  {
    path: routerSegments.accountDetails,
    canActivate: [authenticatedGuard],
    loadComponent: () => LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/account-details/account-details.component').then(
            (m) => m.AccountDetailsComponent,
          ),
      },
    ],
  },
  { path: routerSegments.logout, redirectTo: '', pathMatch: 'full' },
  {
    path: routerSegments.resetPassword,
    component: PublicResetPasswordPageComponent,
  },
  {
    path: routerSegments.emailVerification,
    component: PublicEmailVerificationPageComponent,
  },
  {
    path: routerSegments.accessDenied,
    component: PublicAccessDeniedPageComponent,
  },
  { path: '**', redirectTo: routerSegments.home },
];
